import React, { useState, useEffect, useCallback } from 'react';
import { AgGridReact } from 'ag-grid-react';
import Popup from 'reactjs-popup';
import { GroupService } from './../../service/group.service'
import AddUser from '../common/AddUser';
import AddApplication from '../common/AddApplication';
import Confirmation from '../common/Confirmation';
import Alert from '../common/Alert';

import '../../../node_modules/reactjs-popup/dist/index.css';
import '../../../node_modules/ag-grid-community/styles/ag-grid.css';
import '../../../node_modules/ag-grid-community/styles/ag-theme-alpine.css';

const NewGroup = (params) => {
    const [group, setGroup] = useState([]);
    const [applications, setApplications] = useState([]);
    const [groupUsers, setGroupUsers] = useState([]);
    const [groupApplications, setGroupApplications] = useState([]);
    const [name, setName] = useState([]);
    const [description, setDescription] = useState([]);
    const [message, setMessage] = useState([]);
    const [isAlert, setIsAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [loading, setLoading] = useState(true);
    const [callBackMethod, setCallBackMethod] = useState(false);

    const groupService = new GroupService();

    useEffect(() => {        
        if (loading) {
            const fetchData = async () => {
                const result = await groupService.getGroupById(params.id);
                if (result.data.id > 0) {
                    console.log(result);
                    setGroup(result.data);
                    setApplications(result.data.applicationGroups);

                    var usrData = result.data.users.map(function (a) {
                        return { id: a.id, name: a.name, email: a.email };
                    });
                    setGroupUsers(usrData);
                    localStorage.setItem('groupUsers', JSON.stringify(usrData));

                    var grpApplications = result.data.applicationGroups.map(function (a) {
                        return {
                            id: a.id,
                            name: a.name,
                            applicationId: a.applicationId,
                            groupId: a.groupId,
                            companyNames: a.companyNames,
                            isDefault: a.isDefault,
                            companies: (a.companies ? a.companies : [])
                        };
                    });
                    setGroupApplications(grpApplications);
                    localStorage.setItem('groupApplications', JSON.stringify(grpApplications));

                    setName(result.data.name);
                    setDescription(result.data.description);
                    setLoading(false);
                }
            }

            fetchData()
                .catch(console.error);
        }
    }, [loading]);

    
    const addUsers = (newUsers) => {
        let ids = groupUsers.map(function (a) {
            return a.id;
        });

        newUsers = newUsers.filter((x) => {
            return !ids.includes(x.id);
        });

        let existingUsers = groupUsers;
        existingUsers = existingUsers.concat(newUsers);
        setGroupUsers(existingUsers);
        localStorage.setItem('groupUsers', JSON.stringify(existingUsers));
    };

    const addGroupApplication = (newApp, newCompanies) => {
        let allComNames = newCompanies.map(function (a) {
            return a.label;
        });

        let comNames = String(allComNames);

        let existingApp = groupApplications.filter((x) => {
            return (x.applicationId !== newApp.value);
        });

        let companyDate = newCompanies.map((l) => { return { id: l.value, name: l.label } });
        companyDate = (companyDate ? companyDate : []);

        existingApp.push({
            id: 0,
            name: newApp.label,
            applicationId: newApp.value,
            groupId: group.id,
            companyNames: comNames,
            isDefault: (comNames === "" ? 1 : 0),
            companies: companyDate
        });
        setGroupApplications(existingApp);
        localStorage.setItem('groupApplications', JSON.stringify(existingApp));

        let app = applications.filter((x) => {
            return (x.applicationId !== newApp.value);
        });
        app.push({
            id: 0,
            name: newApp.label,
            applicationId: newApp.id,
            groupId: group.id,
            companyNames: comNames,
            companies: companyDate,
            isDefault: (comNames === "" ? 1 : 0),
            createdDate: new Date(),
            createdBy: 0,
            modifiedDate: new Date(),
            modifiedBy: 0
        });
        setApplications(app);
    };

    const removeUser = (email) => {
        let storedUsers = localStorage.getItem('groupUsers');
        storedUsers = JSON.parse(storedUsers);

        let existingUsers = storedUsers.filter((x) => {
            return (x.email !== email);
        });
        setGroupUsers(existingUsers);
        localStorage.setItem('groupUsers', JSON.stringify(existingUsers));
    };

    const removeApplication = (id) => {
        let storedApps = localStorage.getItem('groupApplications');
        storedApps = JSON.parse(storedApps);
                
        let existingApp = storedApps.filter((x) => {
            return (x.applicationId !== id);
        });
        setGroupApplications(existingApp);
        localStorage.setItem('groupApplications', JSON.stringify(existingApp));

        let app = applications.filter((x) => {
            return (x.applicationId !== id);
        });
        setApplications(app);        
    };

    const setFormInput = (e) => {
        if (e.target.name === "name") {
            setName(e.target.value)
            removeMessage(1);
        }
        else if (e.target.name === "description") {
            setDescription(e.target.value);
            removeMessage(2);
        }
    };

    const removeMessage = (id) => {
        if (message.length > 0) {
            let newMessage = message.filter((m) => {
                return (m.id !== id);
            });
            setMessage(newMessage);
        }
    };

    const onSuccess = async () => {
        if (checkValidation() === true) {
            console.log("I am going to save this group!");
            console.log(groupApplications);
            let groupModel = {
                id: (group.id ? group.id : 0),
                name: name,
                description: description,
                dateCreated: group.dateCreated ? group.dateCreated : new Date(),
                dateModified: group.dateModified ? group.dateModified : new Date(),
                users: groupUsers,
                applicationGroups: groupApplications,
                createdBy: 0,
                modifiedBy: 0,
                isActive: true
            }

            let saveResult = await groupService.saveGroup(groupModel);
            if (saveResult.status === 200) {
                setAlertMessage("Group data has been saved successfully");

                setCallBackMethod(true);
                alertOn(true);
            }
            else {
                setAlertMessage(saveResult.data.message);
                alertOn(true);
            }
        }
    };

    const checkValidation = () => {
        let result = true;
        let newMessage = [];

        if (!name || name.length === 0) {
            newMessage.push({ id: 1, text: "Group name is required" });
            result = false;
        }

        if (!description || description.length === 0) {
            newMessage.push({ id: 2, text: "Group description is required" });
            result = false;
        }

        setMessage(newMessage);
        return result;
    };

    const gridCellRenderer = (params) => {
        if (params.value) {
            let _value = '<span title="' + params.value + '">' + params.value + '</span>';
            return <div dangerouslySetInnerHTML={{ __html: _value }}></div>;
        }
    }

    const deleteCellRenderer = (params) => {
        if (params.data) {
            return <Popup trigger={<i style={{ color: "#970000" }} className="fa fa-trash"></i>} nested modal>{close => (<Confirmation message="Are you sure, you want to delete this application?" data={params.data.applicationId} onSuccess={removeApplication} onClose={() => { close(); }}></Confirmation>)}</Popup>
        }
    }

    const deleteCellRendererUser = (params) => {
        if (params) {
            return <Popup trigger={<i style={{ color: "#970000" }} className="fa fa-trash"></i>} nested modal>{close => (<Confirmation message="Are you sure, you want to delete this user?" data={params.data.email} onSuccess={removeUser} onClose={() => { close(); }}></Confirmation>)}</Popup>

            //let html = '<a title="Delete Group" style="color:#970000;"><i class="fa fa-trash"></i></a>';
            //return <div dangerouslySetInnerHTML={{ __html: html }}></div>;
        }
    }

    const defaultCellRenderer = (params) => {
        if (params.value) {
            let _value = '<a title="Delete Group" style="color:#970000;"><i class="fas fa-check-circle"></i></a>';
            return <div dangerouslySetInnerHTML={{ __html: _value }}></div>;
        }
    }

    //const cellClickedListener = useCallback(event => {
    //    if (event.colDef.colId === 'delete-button') {
    //        if (window.confirm("Are you sure, you want to remove this user: [" + event.data.email + "]") == true) {
    //            removeUser(event.data.email);
    //        }             
    //    }
    //}, []);

    const columnDefs = [
        { headerName: 'Email', field: 'email', filter: true, width: 300, resizable: true, cellRenderer: p => gridCellRenderer(p) },
        { headerName: 'Name', field: 'name', filter: true, width: 250, resizable: true, cellRenderer: p => gridCellRenderer(p) },
        { headerName: '', colId: 'delete-button', field: '', width: 30, sortable: false, resizable: true, cellRenderer: p => deleteCellRendererUser(p) }
    ];

    const gridOptions = {
        columnDefs: columnDefs,
        pagination: true,
        rowSelection: 'single',
        enableFilter: true,
        cacheBlockSize: 25,
        paginationPageSize: 25,
        getRowHeight: (params) => 25,
        suppressMovableColumns: true
    }

    const columnDefsApp = [
        { headerName: 'Application', field: 'name', filter: true, width: 175, resizable: true, cellRenderer: p => gridCellRenderer(p) },
        { headerName: 'Companies', field: 'companyNames', filter: true, width: 275, resizable: true, cellRenderer: p => gridCellRenderer(p) },
        { headerName: 'Default', field: 'isDefault', filter: true, width: 100, resizable: true, cellRenderer: p => defaultCellRenderer(p) },
        { headerName: '', colId: 'delete-button', field: '', width: 30, sortable: false, resizable: true, cellRenderer: p => deleteCellRenderer(p) }
    ];

    const gridOptionsApp = {
        columnDefs: columnDefsApp,
        pagination: true,
        rowSelection: 'single',
        enableFilter: true,
        cacheBlockSize: 25,
        paginationPageSize: 25,
        getRowHeight: (params) => 25,
        suppressMovableColumns: true
    }

    const alertOff = () => {
        setIsAlert(false);

        if (callBackMethod === true) {
            if (params.callBack !== undefined) {
                params.callBack();
            }
            setCallBackMethod(false);
        }

        params.onClose();
    };

    const alertOn = () => {
        setIsAlert(true);
    };

    return (
        <>
            {isAlert && <div><Alert type="error" message={alertMessage} callBack={alertOff} /></div>}

            <div className="card" style={{ width: "675px", marginTop: "-15px", marginLeft: "-15px", marginBottom: "-15px", marginRight: "-15px" }}>
                <h5 className="card-header py-3">
                    <i className="fa fa-folder-open-o" aria-hidden="true"></i> Group
                </h5>
                <div className="card-body">
                    <div>
                        {(message.length > 0) ?
                            <ul>
                                {message.map(m =>
                                    <li style={{ color: "red" }} key={m.id}>{m.text}</li>
                                )}
                            </ul>
                            : ""}
                    </div>
                    <div className="ag-theme-alpine" style={{ height: "450px", overflowY: "auto" }}>
                        <div style={{ marginRight: "5px" }}>
                            <div>
                                <label>Name</label>
                                <input type="text" className="form-control" id="name" name="name" value={name} onChange={(e) => setFormInput(e)} />
                            </div>

                            <div style={{ marginTop: "10px" }}>
                                <label>Description</label>
                                <textarea name="textarea" cols="30" rows="3" className="form-control" id="description" name="description" value={description} onChange={(e) => setFormInput(e)}></textarea>
                            </div>

                            <div style={{ marginTop: "15px" }}>
                                <div>
                                    <label style={{ marginTop: "10px" }}>Users</label>
                                    <Popup trigger={<button style={{ float: "right" }} type="button" className="btn btn-outline-secondary btn-sm"><span><i className="fa fa-plus mr-1"></i></span>Add User</button>} nested modal>{close => (<AddUser callBack={addUsers} onClose={() => { close(); }}></AddUser>)}</Popup>
                                    <div style={{ clear: 'both' }}></div>
                                </div>
                                <div className="ag-theme-alpine" style={{ height: 200, marginTop: "10px" }}>
                                    <AgGridReact
                                        rowData={groupUsers}
                                        //onCellClicked={cellClickedListener}
                                        gridOptions={gridOptions}
                                    />
                                </div>
                            </div>

                            <div style={{ marginTop: "25px" }}>
                                <div>
                                    <label style={{ marginTop: "0px" }}>Applications</label>
                                    <Popup trigger={<button style={{ float: "right" }} type="button" className="btn btn-outline-secondary btn-sm"><span><i className="fa fa-plus mr-1"></i></span>Add Application</button>} nested modal>{close => (<AddApplication callBack={addGroupApplication} onClose={() => { close(); }}></AddApplication>)}</Popup>
                                    <div style={{ clear: 'both' }}></div>
                                </div>
                                <div className="ag-theme-alpine" style={{ height: 200, marginTop: "10px" }}>
                                    <AgGridReact
                                        rowData={groupApplications}
                                        //onCellClicked={cellClickedListenerApp}
                                        gridOptions={gridOptionsApp}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-footer text-muted">
                    <div style={{ textAlign: "center" }}>
                        <button onClick={onSuccess} className="btn btn-secondary" style={{ marginRight: "5px" }}>Save</button>
                        <button className="btn btn-secondary" onClick={params.onClose}>Close</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NewGroup;